import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M392.260066,1042.49958 C530.00695,984.830426 685.109502,1027.23098 818.133008,1158.71664 L818.133008,1158.71664 L822.526848,1163.54987 C939.183299,1309.97459 972.027253,1442.66855 920.399633,1557.78716 C791.550276,1844.92461 179.708056,1886.55624 110.39523,1890.291 L110.39523,1890.291 L-1.13686838e-13,1896.44238 L61.953144,1804.61112 C62.941758,1803.07328 166.96592,1645.88365 166.96592,1377.42003 C166.96592,1235.60884 259.566098,1097.86196 392.260066,1042.49958 Z M1728.70142,23.0518039 C1783.62442,21.9533439 1828.66128,38.3203979 1863.812,72.4825039 C1904.45502,113.125524 1921.92054,160.359304 1919.83346,213.085384 C1908.84886,474.518864 1423.32954,953.447423 1053.14852,1280.7885 C1028.87256,1215.97936 989.437844,1144.57946 927.814238,1067.68726 L927.814238,1067.68726 L919.026558,1057.80112 C838.948824,977.613543 749.863719,922.690543 656.604465,896.327503 C955.275738,558.001824 1460.67718,33.9265579 1728.70142,23.0518039 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconPaintSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconPaintSolid, _Component);

  var _super = _createSuper(IconPaintSolid);

  function IconPaintSolid() {
    _classCallCheck(this, IconPaintSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconPaintSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconPaint",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconPaintSolid.displayName = "IconPaintSolid";
  return IconPaintSolid;
}(Component);

IconPaintSolid.glyphName = 'paint';
IconPaintSolid.variant = 'Solid';
IconPaintSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconPaintSolid;
export { IconPaintSolid };